<app-unit-activity-collapsible-view
  *ngFor="let unit of units"
  [unit]="unit"
  [opened]="openedUnit === unit.ObjGuid"
  ($open)="onOpen($event)"
>
</app-unit-activity-collapsible-view>
